import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";
import { FileType } from "../../interfaces/general";

export interface FileUploadStateInterface {
    files: File[];
    parent?: number;
    hash?: string;
    versionGroup?: string;
    versionByEdit?: boolean;
}

export interface FolderUploadStateInterface {
    files: File[];
    parent?: number;
    hash?: string;
}

export interface EnoughSpaceFilesInterface {
    singleFiles: {
        id: string;
        file: File;
        status: boolean;
        folder: boolean;
    }[];
    folderFiles: {
        id: string;
        file: File;
        status: boolean;
        folder: boolean;
    }[];
}

export interface UploadStateInterface {
    folder: FolderUploadStateInterface;
    file: FileUploadStateInterface;
    enoughSpaceFiles: EnoughSpaceFilesInterface;
    enoughSpaceModal: boolean;
    filesToUpload: FileType[];
}

const uploadSliceState: UploadStateInterface = {
    folder: {
        files: [],
        parent: undefined
    },
    file: {
        files: [],
        parent: undefined
    },
    enoughSpaceFiles: {
        singleFiles: [],
        folderFiles: []
    },
    enoughSpaceModal: false,
    filesToUpload: []
};

export const uploadSlice = createSlice({
    name: "upload",
    initialState: uploadSliceState,
    reducers: {
        setFileUploadState: (state, action: PayloadAction<FolderUploadStateInterface>) => {
            state.file = action.payload;
        },
        setFolderUploadState: (state, action: PayloadAction<FileUploadStateInterface>) => {
            state.folder = action.payload;
        },
        setEnoughSpaceFiles: (state, action: PayloadAction<EnoughSpaceFilesInterface>) => {
            state.enoughSpaceFiles = action.payload;
        },
        setEnoughSpaceFileStatus: (state, action: PayloadAction<{ id: string; folder: boolean }>) => {
            if (action.payload.folder) {
                state.enoughSpaceFiles.folderFiles = state.enoughSpaceFiles.folderFiles.map((item) => {
                    if (item.id === action.payload.id) {
                        return {
                            ...item,
                            status: !item.status
                        };
                    } else {
                        return item;
                    }
                });
            } else {
                state.enoughSpaceFiles.singleFiles = state.enoughSpaceFiles.singleFiles.map((item) => {
                    if (item.id === action.payload.id) {
                        return {
                            ...item,
                            status: !item.status
                        };
                    } else {
                        return item;
                    }
                });
            }
        },
        setEnoughSpaceModal: (state, action: PayloadAction<boolean>) => {
            state.enoughSpaceModal = action.payload;
        },
        setReduxFilesToUpload: (state, action: PayloadAction<FileType[]>) => {
            state.filesToUpload = action.payload;
        }
    }
});

export const { setFileUploadState, setReduxFilesToUpload, setFolderUploadState, setEnoughSpaceFiles, setEnoughSpaceModal, setEnoughSpaceFileStatus } =
    uploadSlice.actions;
export const selectUpload = (state: RootState) => state.upload;
export default uploadSlice.reducer;
